
import React from "react";
import { TableBody, TableRow } from "@/components/ui/table";
import { AdminUser } from "@/hooks/admin/users/types";
import { UserRole, StrategyProvider } from "@/types/strategy-types";
import UserRowGroup from "./UserRowGroup";

interface UsersTableContentProps {
  filteredUsers: AdminUser[];
  strategies: any[];
  providers: StrategyProvider[];
  expandedUsers: string[];
  editingUser: string | null;
  editFirstName: string;
  editLastName: string;
  onToggleExpand: (userId: string) => void;
  onEditFirstNameChange: (value: string) => void;
  onEditLastNameChange: (value: string) => void;
  onStartEdit: (user: AdminUser) => void;
  onCancelEdit: () => void;
  onSaveEdit: (userId: string) => void;
  onUpdateRole: (roleId: string, newRole: UserRole) => Promise<void>;
  onUpdateName: (userId: string, firstName: string, lastName: string) => Promise<void>;
  onDeleteUser: (userId: string) => void;
  getProviderStrategies: (providerId: string | undefined) => any[];
  getAssignedProvider: (providerId: string | undefined) => any | null;
}

const UsersTableContent = ({
  filteredUsers,
  strategies,
  providers,
  expandedUsers,
  editingUser,
  editFirstName,
  editLastName,
  onToggleExpand,
  onEditFirstNameChange,
  onEditLastNameChange,
  onStartEdit,
  onCancelEdit,
  onSaveEdit,
  onUpdateRole,
  onUpdateName,
  onDeleteUser,
  getProviderStrategies,
  getAssignedProvider
}: UsersTableContentProps) => {
  if (filteredUsers.length === 0) {
    return (
      <TableBody>
        <TableRow>
          <td colSpan={6} className="py-6 text-center text-muted-foreground">
            No users found
          </td>
        </TableRow>
      </TableBody>
    );
  }

  console.log("Filtered users in UsersTableContent:", filteredUsers);

  return (
    <TableBody>
      {filteredUsers.map(user => (
        <UserRowGroup
          key={user.id}
          user={user}
          expandedUsers={expandedUsers}
          editingUser={editingUser}
          editFirstName={editFirstName}
          editLastName={editLastName}
          onToggleExpand={onToggleExpand}
          onEditFirstNameChange={onEditFirstNameChange}
          onEditLastNameChange={onEditLastNameChange}
          onStartEdit={onStartEdit}
          onCancelEdit={onCancelEdit}
          onSaveEdit={onSaveEdit}
          onUpdateRole={onUpdateRole}
          onUpdateName={onUpdateName}
          onDeleteUser={onDeleteUser}
          getProviderStrategies={getProviderStrategies}
          getAssignedProvider={getAssignedProvider}
        />
      ))}
    </TableBody>
  );
};

export default UsersTableContent;
